import { classNames } from "@/react/helpers/twMergeWithCN";
import { getBlockName } from "@circle-react-shared/BuilderUI/Helpers/getBlockName";
import {
  useBuilderStore,
  useSelectedBlock,
} from "@circle-react-shared/BuilderUI/Hooks/useBuilderStore";
import { Typography } from "@circle-react-uikit/Typography";

export interface CanvasBlockNameProps {
  "data-testid"?: string;
}

const stylesMap = {
  firstBlock: {
    position: "-top-1",
    borderRadius: "rounded-b-[0.3125rem]",
  },
  default: {
    position: "-top-6",
    borderRadius: "rounded-t-[0.3125rem]",
  },
} as const;

export const CanvasBlockName = ({
  "data-testid": dataTestId = "canvas-block-name",
}: CanvasBlockNameProps) => {
  const { meta } = useSelectedBlock();
  const selectedBlockPath = useBuilderStore(state => state.selectedBlockPath);

  const isFirstBlockSelected =
    selectedBlockPath === "blocks.props.children.value.0";

  const blockName = meta ? getBlockName(meta) : "";
  if (!blockName) return null;

  const styles = isFirstBlockSelected
    ? stylesMap["firstBlock"]
    : stylesMap["default"];

  return (
    <div
      className={classNames(
        "bg-circle pointer-events-auto absolute -left-1 flex items-center px-3 py-1",
        styles.position,
        styles.borderRadius,
      )}
      data-testid={dataTestId}
    >
      <Typography.LabelXxs
        weight="semibold"
        color="text-white"
        leading="leading-4"
        tracking="tracking-wide"
      >
        {blockName}
      </Typography.LabelXxs>
    </div>
  );
};
